import { Body, HellodialogClient } from "../../../../Shared/backendApi/generated"
import { extendedHttpResult } from "../../../../Shared/backendApi/utils"
import { FormState } from "./newsletterFormBlockState"

const client = new HellodialogClient(window.location.origin)
const token = () => (document.getElementsByName("__RequestVerificationToken")[0] as any).value

export const submitForm = (data: FormState) => extendedHttpResult(() => client.inschrijven(token(), toRequest(data)))

const toRequest = (data: FormState): Body => ({
  email: data.emailAddress,
  voornaam: data.firstName,
  achternaam: data.lastName,
  geslacht: data.gender,
  groups: data.newsletters.toArray(),
  _state: "Contact",
  _language: "NL",
})
